/**
 * @generated SignedSource<<108da585145b3ad724d9cefcf2993103>>
 * @relayHash bc7b927fba23b36d639f0645f0dbc924
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc7b927fba23b36d639f0645f0dbc924

import type { ConcreteRequest } from 'relay-runtime';
export type CreateLabelInput = {
  clientMutationId?: string | null | undefined;
  color: string;
  description?: string | null | undefined;
  name: string;
  repositoryId: string;
};
export type createItemPickerLabelMutation$variables = {
  input: CreateLabelInput;
};
export type createItemPickerLabelMutation$data = {
  readonly createLabel: {
    readonly label: {
      readonly color: string;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly nameHTML: string;
      readonly url: string;
    } | null | undefined;
  } | null | undefined;
};
export type createItemPickerLabelMutation$rawResponse = {
  readonly createLabel: {
    readonly label: {
      readonly color: string;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly nameHTML: string;
      readonly url: string;
    } | null | undefined;
  } | null | undefined;
};
export type createItemPickerLabelMutation = {
  rawResponse: createItemPickerLabelMutation$rawResponse;
  response: createItemPickerLabelMutation$data;
  variables: createItemPickerLabelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateLabelPayload",
    "kind": "LinkedField",
    "name": "createLabel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Label",
        "kind": "LinkedField",
        "name": "label",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameHTML",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createItemPickerLabelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createItemPickerLabelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "bc7b927fba23b36d639f0645f0dbc924",
    "metadata": {},
    "name": "createItemPickerLabelMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "433349a516ae22925f3be8a399d79a08";

export default node;
